import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { useViewMode } from '@/stores/viewMode'

interface MonthlyStats {
  monthYear: string
  totalPlayCount: number
}

export function useAdPlayMonthlyStats() {
  const { token } = useAuth()
  const { mode, id: viewModeId } = useViewMode()
  const providerId = mode === 'provider' && viewModeId ? viewModeId : undefined

  // 獲取當前和上個月的年月
  const currentDate = new Date()
  const currentMonth = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`

  const lastMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
  const lastMonth = `${lastMonthDate.getFullYear()}-${String(lastMonthDate.getMonth() + 1).padStart(2, '0')}`

  // 使用新的聚合統計端點
  const providerQuery = providerId ? `&providerId=${providerId}` : ''
  const { data, error, mutate } = useGet<ApiResponse<MonthlyStats[]>>(
    token
      ? `/api/ad-play/monthly/stats?startMonth=${lastMonth}&endMonth=${currentMonth}${providerQuery}`
      : null,
    undefined,
    token ?? '',
  )

  // 從聚合數據中提取統計
  const statsData = data?.data || []
  const currentMonthTotal =
    statsData.find((item) => item.monthYear === currentMonth)?.totalPlayCount || 0
  const lastMonthTotal = statsData.find((item) => item.monthYear === lastMonth)?.totalPlayCount || 0

  // 計算成長率
  let growthRate = 0
  if (lastMonthTotal > 0) {
    growthRate = ((currentMonthTotal - lastMonthTotal) / lastMonthTotal) * 100
  }

  return {
    currentMonthTotal,
    lastMonthTotal,
    growthRate,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
